import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ClientCompanyType = {
  typeId: string;
  // Add other properties as needed
};

type ClientCompanyTypesState = {
  types: ClientCompanyType[];
};

const initialState: ClientCompanyTypesState = {
  types: [],
};

export const clientCompanyTypesSlice = createSlice({
  name: 'clientCompanyTypes',
  initialState,
  reducers: {
    setClientCompanyTypes: (
      state,
      action: PayloadAction<ClientCompanyType[]>,
    ) => {
      state.types = action.payload;
    },
  },
});

export const { setClientCompanyTypes } = clientCompanyTypesSlice.actions;

export default clientCompanyTypesSlice.reducer;
